import { User } from '@/graphql/graphql';
import { useMe } from '@/hooks/useMe';
import { FC, createContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export interface iUserContext {
  user: Partial<User> | null;
  token: string | null;
  setToken: (token: string) => void;
  setUser: (val: Partial<User> | null) => void;
  refresh: (obj: any) => void;
}
export const UserContext = createContext<iUserContext>({
  user: null,
  setUser: () => null,
  token: null,
  setToken: () => null,
  refresh: () => null,
});
interface iProviderProps {
  children?: any;
}

const Provider: FC<iProviderProps> = ({ children }) => {
  const { loadMe } = useMe();

  useEffect(() => {
    loadMe();
  }, []);

  return (
    <>
      {children}
      <Outlet />
    </>
  );
};

export default Provider;
